export const ENDPOINTS = {
    // Jobs
    fetch_accounts: '/jobs/fetchaccounts',
    fetch_jobs: '/jobs/fetch',
    fetch_job: '/job/fetch',
    job_search: '/jobs/search',
    job_getloc: '/job/getloc/',
    jobs_editbulk: '/job/editbulk/',
    job_delete: '/job/delete/',
    job_editsingle: '/job/editsingle/',
    job_sendpod: '/job/sendpod/',
    job_edit: '/job/edit/',
    job_add: '/job/add',
    job_start_transit: '/job/starttransit/',
    jobs_custom_email: '/jobs/customEmail',
    job_welcome_email: '/jobs/welcomeemail',
    save_collection: '/jobs/savecollection',
    // Manifest
    manifest_client: '/manifest/client',
    manifest_edit: '/manifest/edit/',
    manifests: '/manifests',
    manifest_add: '/manifest/add',
    manifest_delete: '/manifest/delete/',
    // Users
    user_edit: '/user/edit/',
    users: '/users',
    user_login: '/user/login',
    user_sendresetlink: '/user/sendresetlink',
    user_add: '/user/add',
    // Notifications
    notifications_fetch: '/notifications/fetch',
    notifications_driverreports: '/notifications/driverreports',
    notifications_read: '/notification/read',
    notifications: '/notifications',
    notification_add: '/notification/add',
    // Freight Codes
    freightcode_edit: '/freightcode/edit/',
    freightcodes: '/freightcodes',
    freightcode_add: '/freightcode/add',
    // Drivers
    driver_edit: '/drivers/edit/',
    driver_delete: '/driver/delete/',
    drivers: '/drivers',
    driver_add: '/driver/add',
    // Collections
    collection_upload: '/collection/upload/collection',
    collection_edit: '/collection/edit/',
    collection_add: '/collection/add',
    // Clients
    client_delete: '/client/delete/',
    client_edit: '/clients/edit/',
    clients: '/clients',
    client_bulkadd: '/client/bulkadd',
    client_add: '/client/add',
    // Addresses
    address_delete: '/address/delete/',
    address_edit: '/address/edit/',
    addresses: '/addresses',
    address: '/address',
    address_bulkadd: '/address/bulkadd',
    address_add: '/address/add',
    // Xero
    xero_auth: '/xero/auth',
    // Version
    get_version: '/version',
    // Settings
    update_settings: '/settings/update',
    get_settings: '/settings',
    // Plan
    get_plan: '/plans',
    // Subscription
    get_subscription: '/subscription',
    // Property
    update_job_property: '/updatejobproperty',
    get_table_properties_params: '/gettableproperties'
};